"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceBindingNode = isInstanceBindingNode;
const BindingType_1 = require("../../binding/models/BindingType");
function isInstanceBindingNode(node) {
    return node.binding.type === BindingType_1.bindingTypeValues.Instance;
}
//# sourceMappingURL=isInstanceBindingNode.js.map